module.exports = __webpack_public_path__ + "static/media/profile4.b942925d.jpg";